import React from 'react';
import type { LayoutProps } from './types';
import { getImageUrl } from './utils';

export const DividerLayout: React.FC<LayoutProps> = ({
  filteredItems,
  colors,
  data,
  imageRefs,
  onImageClick,
}) => {
  return (
    <div
      className="overflow-x-auto scroll-smooth -mx-4 sm:-mx-6 lg:-mx-8"
      style={{ scrollbarWidth: 'thin' }}
    >
      <div className="flex gap-0">
        {filteredItems.map((item, index) => {
          const imageUrl = getImageUrl(item);
          return (
            <div
              key={item.id}
              className="flex-shrink-0 relative group overflow-hidden cursor-pointer"
              onClick={() => onImageClick(index)}
            >
              <div className="h-40 md:h-56 w-auto">
                <img
                  ref={
                    data.lazyLoading
                      ? el => {
                          imageRefs.current[index] = el;
                        }
                      : undefined
                  }
                  src={imageUrl}
                  alt={item.alt || `Gallery image ${index + 1}`}
                  className="h-full w-auto object-cover"
                  loading={data.lazyLoading ? 'lazy' : undefined}
                />
              </div>
              {data.captionPosition === 'overlay' && item.caption && (
                <div className="absolute bottom-0 left-0 right-0 bg-black/70 p-2 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-xs md:text-sm" style={{ color: colors.captionColor }}>
                    {item.caption}
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
